import React from "reactn";
import { StepIndicator } from "../../../../components/UI";
import Setup from "./Setup";
import Template from "./Forms/Template"; 
import Schedule from "./Forms/Schedule"; 
import StepBar from "../../../../components/UI/StepBar";
import { withRouter } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { Icon } from "semantic-ui-react";

class AutomationStructure extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      step: 0,
      automation: this.props.location.state?.initialAutomation || {
        communicationType: "",
        automationType: "",
        automationFor: "",
        audience: [],
        templateId: "",
        timing: "",
        timingUnit: "",
        enabled: true,
        isArchived: false
      }, 
      templates: []
    };
    this.titles = ["Design", "Template", "Schedule"];
    this.steps = [
      { name: "Design", validateFn: () => this.validateStep(0) },
      { name: "Template", validateFn: () => this.validateStep(1) },
      { name: "Schedule", validateFn: () => this.validateStep(2) }
    ];
  }

  async componentDidMount() {

    try {
      const ep = `${process.env.REACT_APP_API}/partners/connections`;
      const response = await axios.get(ep);
      if (response.data.success) {
        this.setState({ templates: response.data.data.templates });
      }
    } catch (error) {
      console.error("Error fetching templates:", error);
    }

    const savedAutomation = localStorage.getItem('currentAutomation');
    if (savedAutomation) {
      this.setState({ automation: JSON.parse(savedAutomation) });
    } else if (this.props.location.state?.initialAutomation) {
      // if no saved state but we have initial state, save it
      localStorage.setItem('currentAutomation', JSON.stringify(this.props.location.state.initialAutomation));
    }

    // if theres an id, fetch the automation
    if (this.props.match.params.id) {
      try {
        const ep = `${process.env.REACT_APP_API}/partners/automations/${this.props.match.params.id}`;
        const response = await axios.get(ep);
        if (response.data.success) {
          const automation = response.data.data;
          if (automation.audience && typeof automation.audience === 'string') {
            try {
              automation.audience = JSON.parse(automation.audience);
            } catch (parseError) {
              console.error("Error parsing audience JSON:", parseError);
              automation.audience = [];
            }
          } else if (!automation.audience) {
            automation.audience = [];
          }
          this.setState({ automation });
          localStorage.setItem('currentAutomation', JSON.stringify(automation));
        }
      } catch (error) {
        console.error("Error fetching automation:", error);
      }
    }

    this.setGlobal({
      partnerPathway: [
        ...this.global.partnerPathway.slice(0, 1),
        { label: "Automations", to: "/automations" },
        {
          label: "Automation Setup",
          to: this.props.location.pathname
        }
      ]
    });
  }

  validateStep = (step) => {
    const { automation } = this.state;
    switch(step) {
      case 0: 
        return automation.communicationType && 
        automation.automationType && 
        automation.automationFor &&
        Array.isArray(automation.audience) && 
        automation.audience.length > 0;
      case 1: 
        return automation.templateId;
      case 2: 
        return automation.timing && automation.timingUnit;
      default:
        return false;
    }
  };

  handleAutomationChange = (updates) => {
    this.setState(prevState => {
      const newAutomation = {
        ...prevState.automation,
        ...updates
      };
      localStorage.setItem('currentAutomation', JSON.stringify(newAutomation));
      return { automation: newAutomation };
    });
  };

  saveProfile = async e => {
    const { step, automation } = this.state;
    
    if (e.target.name !== "back" && !this.validateStep(step)) {
      return; 
    }
  
    switch (e.target.name) {
      case "next":
        this.setState({ step: step + 1 });
        break;
      case "back":
        this.setState({ step: step - 1 });
        break;
      case "publish":
      case "save":
        try {
          const ep = `${process.env.REACT_APP_API}/partners/automations`;
          const response = await axios.post(ep, automation);
          
          if (response.data.success) {
            const isEditing = automation.id;
            toast.success(isEditing ? "Automation updated successfully!" : "Automation created successfully!");
            localStorage.removeItem('currentAutomation');
            this.props.history.push("/partners/automations");
          } else {
            toast.error(response.data.message || "Failed to save automation");
          }
        } catch (error) {
          console.error("Error saving automation:", error);
          toast.error("Failed to save automation");
        }
        break;
      default:
        return;
    }
  };

  changePage = async page => {
    if (this.validateStep(page)) {
      this.setState({ step: page });
    }
  };

  getPage = () => {
    const { step, automation, templates } = this.state;

    const commonProps = {
      automation,
      onAutomationChange: this.handleAutomationChange, 
      templates: templates || []
    };

    switch (step) {
      case 0:
        return <Setup {...commonProps} />;
      case 1:
        return <Template {...commonProps} />;
      default:
        return <Schedule {...commonProps} />;
    }
  };

  getCompletion = () => {
    let completed = 0;
    for (let step of this.steps) {
      if (step.validateFn()) completed++;
    }
    return (completed / this.steps.length) * 100;
  };

  render() {

    return (
      <div className="container-fluid" style={{ boxShadow: 'none', borderRadius: '0px' }}>
        <div className="cont" style={{ boxShadow: 'none', borderRadius: '0px' }}>
          <h1>
            Automation Setup <span>{this.titles[this.state.step]}</span>
          </h1>
        </div>
        <StepBar
          {...{
            steps: this.steps,
            changeFn: this.changePage,
            current: this.state.step
          }}
        />
        <StepIndicator value={this.getCompletion()} />
        {this.getPage()}
        <div className="cont" style={{ marginTop: "20px" }}>
          <div className="row">
          <div className="col-12 d-flex justify-content-center" style={{ gap: '20px' }}>
              {this.state.step > 0 && (
                <button
                className="btn btn-secondary"
                onClick={this.saveProfile}
                name="back"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '44px',   
                  height: '44px',  
                  borderRadius: '50%',
                  border: 'none',
                  backgroundColor: '#1a56db',
                  color: 'white',
                  cursor: 'pointer',
                  padding: 0, 
                  fontSize: '1.1rem',
                  fontWeight: '500'
                }}
              >
                <Icon 
                  name='chevron left' 
                  style={{ 
                    fontSize: '1.2rem',
                    margin: 0,
                    padding: 0, 
                    lineHeight: '1',
                    pointerEvents: 'none'
                  }}
                />
              </button>
              )}
              {this.state.step < this.steps.length - 1 ? (
                <button
                className="btn btn-primary"
                onClick={this.saveProfile}
                name="next"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '44px',   
                  height: '44px',  
                  borderRadius: '50%',
                  border: 'none',
                  backgroundColor: '#1a56db',
                  color: 'white',
                  cursor: 'pointer',
                  padding: 0, 
                  fontSize: '1.1rem',
                  fontWeight: '500'
                }}
              >
                <Icon 
                  name='chevron right' 
                  style={{ 
                    fontSize: '1.2rem',
                    margin: 0,
                    padding: 0, 
                    lineHeight: '1',
                    pointerEvents: 'none'
                  }}
                />
              </button>
              ) : (
                <button
                className="btn btn-success"
                onClick={this.saveProfile}
                name={this.state.automation.id ? "save" : "publish"}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '8px 16px',
                  borderRadius: '8px',
                  border: 'none',
                  backgroundColor: '#059669',
                  color: 'white',
                  cursor: 'pointer',
                  fontSize: '1.1rem',
                  fontWeight: '500'
                }}
              >
                {this.state.automation.id ? "Save" : "Publish"}
                <Icon 
                  name='check' 
                  style={{ 
                    fontSize: '1.2rem',
                    margin: 0,
                    padding: 0, 
                    lineHeight: '1',
                    pointerEvents: 'none'
                  }}
                />
              </button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(AutomationStructure);